import React from 'react'
import {
  useFindOrCreateSalesSeriesConfiguration,
  useGetSalesSeriesConfigurables,
  useUpdateSalesSeriesConfiguration,
} from 'src/api/queries/trade'
import ConfigurationPanel from 'src/components/configuration-panel/ConfigurationPanel'
import { useToast } from 'src/utils/toast'
import { useNavigate, useParams } from 'react-router-dom'
import { Box, Button, VStack } from '@chakra-ui/react'
import { useCompanyContext } from 'src/companies/routes/company-context'
import { getEnvironment } from 'src/utils'
import { ArrowBackIcon } from '@chakra-ui/icons'

export default function SalesSeriesConfigPage() {
  const { company } = useCompanyContext()
  const toast = useToast()
  const navigate = useNavigate()
  const { id: salesSeriesId } = useParams()
  const { data: configurables } = useGetSalesSeriesConfigurables()
  const { data: locationConfig } = useFindOrCreateSalesSeriesConfiguration({ salesSeriesId })
  const { mutateAsync } = useUpdateSalesSeriesConfiguration()

  const salesSeriesIndex = [
    null,
    'companies',
    getEnvironment(),
    company.slug,
    'markets',
    '#Sales Series',
  ].join('/')

  const onSave = async (updateData: KeyValuePair[]) => {
    await mutateAsync({
      updates: {
        salesSeriesId: salesSeriesId ?? null,
        configurations: updateData.filter((kvp) => kvp.value),
      },
    })
    toast({ title: 'Success', description: 'Updated sales series configurations' })
  }

  return (
    <VStack spacing={4} alignItems="start" width="100%">
      <Button
        variant="link"
        colorScheme="primary"
        leftIcon={<ArrowBackIcon />}
        onClick={() => navigate(salesSeriesIndex)}
      >
        Back
      </Button>
      <Box w="100%">
        <ConfigurationPanel
          configurations={configurables}
          data={locationConfig}
          onSave={onSave}
          editPermission="offer_management_edit"
          openInEdit={!salesSeriesId}
          navigateToOnDoneEditing={!salesSeriesId ? salesSeriesIndex : undefined}
          alwaysExpanded
        />
      </Box>
    </VStack>
  )
}
